import http from 'hub-http/clients/apiClient';
import { stringify } from 'hub-http/helpers/params';
import * as ApiRoutes from 'automation-ui-canvas/data/api/ApiRoutes';
import * as ClassicApiRoutes from 'automation-ui-canvas/data/api/ClassicApiRoutes';
import * as BulkProcessingTypes from 'automation-ui-canvas/constants/BulkProcessingTypes';
import AuditEventHistoryFilters from 'automation-ui-management/records/AuditHistory/AuditEventHistoryFilters';
export const getClassicWorkflowMigrationStatusById = workflowId => http.get(`${ApiRoutes.MIGRATION_STATUS}/${workflowId}/status`);

// https://git.hubteam.com/HubSpot/Automation/blob/fa55171eafaf9b59855baeb1f00544e50b1aaa42/AutomationBase/src/main/java/com/hubspot/automationapi/workflow/WorkflowContactListsData.java#L6

export const getHybridFlowPerformanceListCounts = flowId => http.get(`${ClassicApiRoutes.HYBRID_PERFORMANCE_LIST_COUNTS}/${flowId}/list-counts`);
export const getFlowRevisionById = ({
  flowId,
  revisionId
}) => {
  return http.get(`${ApiRoutes.HYBRID_FLOW_REVISIONS}/${flowId}/${revisionId}`);
};
export const getPagedFlowRevisions = (flowId, pageId, auditEventHistoryFilters = new AuditEventHistoryFilters()) => {
  const MAX_LIMIT = 100;
  let route = `${ApiRoutes.HYBRID_FLOW_REVISIONS}/${flowId}?${stringify({
    limit: MAX_LIMIT,
    includeAssociatedBulkEnrollments: true
  })}`;
  if (pageId) {
    route += `&after=${pageId}`;
  }
  if (auditEventHistoryFilters instanceof AuditEventHistoryFilters && auditEventHistoryFilters.filtersAreApplied()) {
    route += `&${auditEventHistoryFilters.getStringifiedFiltersForApi()}`;
  }
  return http.get(route);
};
export const createBulkEnrollment = ({
  flowId,
  objectTypeId,
  selectedIds
}) => {
  const data = selectedIds.map(id => ({
    flowId,
    objectTypeId,
    objectId: id
  }));
  return http.post(ApiRoutes.BULK_ENROLLMENTS, {
    data
  });
};
export const createBulkEnrollmentByListId = ({
  flowId,
  listId
}) => {
  const data = {
    flowId,
    metadata: {
      listId,
      bulkProcessingType: BulkProcessingTypes.BULK_ENROLL
    }
  };
  return http.post(ApiRoutes.BULK_PROCESSING, {
    data
  });
};
export const createBulkEnrollmentByDatasetId = ({
  flowId,
  datasetId
}) => {
  const data = {
    flowId,
    metadata: {
      bulkProcessingType: BulkProcessingTypes.BULK_ENROLL,
      objectSelector: {
        objectSelectorType: 'DATASET',
        datasetId
      }
    }
  };
  return http.post(ApiRoutes.BULK_PROCESSING, {
    data
  });
};
export const fetchBulkProcessingStatus = (flowId, completionStatus) => {
  return http.get(`${ApiRoutes.BULK_PROCESSING}/flow/${flowId}?completionStatus=${completionStatus}`);
};
export const simulateFlowDynamicLogEvents = ({
  flowId,
  objectId,
  branchOverrides,
  enrollType,
  sendEmailsToUser
}) => http.post(`${ApiRoutes.FLOWS_SIMULATE_DYNAMIC_LOGS}/${flowId}/${objectId}`, {
  data: {
    enrollType,
    branchOverrides,
    sendEmailsToUser
  },
  timeout: 30000
});
export const validateFlow = flowId => http.get(`${ApiRoutes.VALIDATION}/${flowId}?isEnabled=true`);

/**
 * Validation should always be done with the
 * flow in "enabled" mode to ensure we're getting
 * all errors that would prevent turning the flow on.
 */
export const validateFlowObject = flow => http.post(ApiRoutes.VALIDATION, {
  data: Object.assign({}, flow.getSanitizedFlow().toJS(), {
    isEnabled: true
  })
});